import { ArrowsClockwiseIcon, WalletIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";

import { useAccountCurrency } from "@/client/services/currency/currency";

import type { Wallet } from "../types/wallet";

interface WalletBalanceCardProps {
  wallet: Wallet | undefined;
  loading: boolean;
  refreshing: boolean;
  onRefresh: () => void;
}

export const WalletBalanceCard = ({
  wallet,
  loading,
  refreshing,
  onRefresh,
}: WalletBalanceCardProps) => {
  const { format } = useAccountCurrency();

  return (
    <article className="relative overflow-hidden rounded-2xl border border-indigo-100 bg-gradient-to-br from-white via-white to-indigo-50/70 p-6 shadow-[0_10px_30px_rgba(30,27,75,0.06)] transition-all hover:shadow-md">
      <div className="absolute -right-12 -top-12 size-36 rounded-full bg-emerald-200/30 blur-2xl" />

      <div className="relative flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="flex size-12 items-center justify-center rounded-xl bg-indigo-100 text-indigo-700">
            <WalletIcon size={24} weight="duotone" />
          </div>

          <div>
            <h2 className="text-sm font-medium text-slate-500">Solde disponible</h2>

            <div className="mt-1 flex items-baseline gap-1">
              {loading && !wallet ? (
                <div className="h-8 w-32 animate-pulse rounded-md bg-slate-200" />
              ) : (
                <span className="text-3xl font-bold tracking-tight text-[#071451] sm:text-4xl">
                  {format(wallet?.balance ?? 0)}
                </span>
              )}
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={onRefresh}
          disabled={refreshing || loading}
          className={cn(
            "relative flex size-10 items-center justify-center rounded-full border border-indigo-100 bg-white text-indigo-500 transition-colors",
            "hover:bg-indigo-50 hover:text-indigo-700",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
            "disabled:cursor-not-allowed disabled:opacity-50",
          )}
          aria-label="Actualiser le solde"
        >
          <ArrowsClockwiseIcon
            size={20}
            className={refreshing ? "animate-spin text-indigo-700" : ""}
          />
        </button>
      </div>
    </article>
  );
};
